import { StatsRepository } from "../../../../data/repository/stats/StatsRepository";
import { ResponseState, State } from "../../../model/ResponseState";
import { AllStats } from "../../../model/Stats";

export interface GetAllStatsUseCase {
  invoke: () => Promise<ResponseState<AllStats>>;
}

export class GetAllStatsUseCaseImpl implements GetAllStatsUseCase {
  private statsRepository: StatsRepository;

  constructor(statsRepository: StatsRepository) {
    this.statsRepository = statsRepository;
  }

  async invoke(): Promise<ResponseState<AllStats>> {
    try {
      let response = await this.statsRepository.getAllStats();
      if (response.isSuccessful) {
        return {
          responseState: State.Success,
          data: response.body!,
        };
      }
      return { responseState: State.Fail, error: response.errorBody! };
    } catch (error) {
      return {
        responseState: State.Error,
        error: { message: String(error), statusCode: 500 },
      };
    }
  }
}
